<script>
import Hls from "hls.js";

export default {
    props: {
        src: String,
        sources: Array,
    },

    data: () => ({
        hls: null,
        stream: null,
        observer: null,
    }),

    methods: {
        setupResizeObserver() {
            const video = this.$refs.video;

            this.observer = new ResizeObserver(() => {
                this.stream = this.getStream();
            });

            this.observer.observe(video);
        },

        setupVideoPlayer() {
            const video = this.$refs.video;

            if (!this.stream) {
                video.src = undefined;
                if (this.hls) this.hls.destroy();
            }

            if (this.nativeSupport()) {
                video.src = this.stream;
            } else if (Hls.isSupported()) {
                if (this.hls) this.hls.destroy();

                this.hls = new Hls();
                this.hls.loadSource(this.stream);
                this.hls.attachMedia(video);
            } else {
                console.error("Device cannot play HLS video.");
            }
        },

        getStream() {
            if (this.src) return this.src;

            const source = this.sources.find((src) => {
                return !src.sizes || window.matchMedia(src.sizes).matches;
            });

            return source?.src;
        },

        nativeSupport() {
            return this.$refs.video.canPlayType("application/vnd.apple.mpegurl");
        },
    },

    watch: {
        stream(stream, old) {
            if (stream === old) return;
            this.setupVideoPlayer();
        },
    },

    mounted() {
        this.stream = this.getStream();
        this.setupVideoPlayer();
        this.setupResizeObserver();
    },

    render(h) {
        return h("video", {
            ref: "video",
        });
    },

    beforeDestroy() {
        this.hls && this.hls.destroy();
        this.observer && this.observer.disconnect();
    },
};
</script>
